<template>
  <div>
    <v-dialog
      v-model="dialog"
      @click:outside="handleCloseDialog"
      @keydown.esc="handleCloseDialog"
      scrollable
      :persistent="innerLoading != false"
      max-width="55vw"
    >
      <v-row class="ma-0 pa-0">
        <v-col class="pa-0 ma-0">
          <v-card rounded="0" height="100%">
            <v-toolbar dark dense class="white--text" flat color="primary">
              <v-toolbar-title class="font-weight-regular my-4"
                >Actualizar Imagen
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-container>
                <v-row v-if="dialog">
                  <v-col cols="12" sm="12">
                    <v-skeleton-loader
                      :loading="loading"
                      height="50"
                      type="list-item"
                    >
                      <PropertyInputFileImage
                        label="Subir Imagen"
                        :image_default="currentImageUrl"
                        @changeImage="handleChangeImage"
                      />
                    </v-skeleton-loader>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn
                outlined
                color="error"
                width="200px"
                @click="handleCloseDialog"
                >Cancelar</v-btn
              >
              <v-btn
                color="primary"
                width="200px"
                @click="saveUpdates"
                :loading="isUploadUpdates"
                :disabled="!newImage"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

import PropertyInputFileImage from "./PropertyInputFileImage.vue";
export default {
  components: {
    PropertyInputFileImage
  },
  props: {
    dialog: { type: Boolean, default: false },
    property_id: { type: String, default: "" }
  },
  computed: {
    ...mapState({
      property: state => state.properties.actualItem
    }),
    currentImageUrl() {
      if (this.property?.media?.featured_image?.src) {
        return this.property.media.featured_image.src;
      }
      if (this.property?.media?.plane_image?.src) {
        return this.property.media.plane_image.src;
      }
      return "";
    },
    currentImageType() {
      if (this.property?.media?.featured_image?.src) {
        return "featured_image";
      }
      return "plane_image";
    }
  },
  data() {
    return {
      loading: false,
      innerLoading: false,
      newImage: null,
      isUploadUpdates: false
    };
  },
  watch: {
    dialog() {
      if (this.dialog && this.property_id) {
        this.fetchProperty(this.property_id);
      }
    }
  },
  methods: {
    ...mapActions({
      fetchProperty: "properties/fetchActualProperty",
      fetchUpdatelProperty: "properties/fetchUpdatelProperty"
    }),
    setDialog(show) {
      this.$emit("setDialog", show);
    },
    clearForm() {
      this.loading = false;
      this.innerLoading = false;
      this.newImage = null;
    },
    async saveUpdates() {
      if (!this.property_id || !this.newImage) return;

      this.isUploadUpdates = true;
      const urlNewImage = await this.uploadImage(this.newImage);
      this.isUploadUpdates = false;

      if (!urlNewImage) return;

      const media = { [this.currentImageType]: { src: urlNewImage } };

      this.isUploadUpdates = true;
      this.$snotify.async(
        "Actualizando propiedad",
        "Actualizando ...",
        () =>
          new Promise((resolve, reject) => {
            this.fetchUpdatelProperty({
              propertyId: this.property_id,
              property: { media }
            })
              .then(() => {
                resolve({
                  title: "Propiedad editada",
                  body: "La propiedad se ha editado correctamente.",
                  config: {
                    closeOnClick: true,
                    titleMaxLength: 30,
                    timeout: 1000
                  }
                });
                this.setDialog(false);
              })
              .catch(err => {
                reject({
                  title: "Error!!!",
                  body: `Ocurrio un problema al actualizar la propiedad. ${err}`,
                  config: {
                    closeOnClick: true,
                    timeout: 2000
                  }
                });
              })
              .finally(() => {
                this.isUploadUpdates = false;
              });
          })
      );
    },
    async uploadImage(newImage) {
      const url =
        "https://api.cloudinary.com/v1_1/capital28-investments/upload";
      try {
        let formData = new FormData();
        formData.append("file", newImage);
        formData.append("upload_preset", "presentation_image");
        const data = await fetch(url, { method: "POST", body: formData });
        const json = await data.json();
        return json.secure_url;
      } catch (e) {
        this.$snotify.error(`Ocurrio un erro al cambiar la imagen.`, `Error!`, {
          closeOnClick: true,
          timeout: 4000
        });
      }
    },
    handleChangeImage(newImage) {
      this.newImage = newImage;
    },
    handleCloseDialog() {
      this.setDialog(false);
      this.newImage = null;
    }
  }
};
</script>
